<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'TASK_TEMPLATE.TEMPLATES_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <button mat-raised-button type="button" class="btn btn-primary" (click)="addTemplate()">
          <span
            inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
            class="svg-icon svg-icon-md"
          ></span>
          <span>{{ 'TASK_TEMPLATE.ADD_TEMPLATE' | translate }}</span>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            type="button"
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          type="button"
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'TASK_TEMPLATE.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">{{ template.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.ID' | translate }}</mat-label>
              <input matInput #searchIdInput [placeholder]="'TASK_TEMPLATE.ID' | translate" />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'TASK_TEMPLATE.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              matTooltip="Edit Task Template"
              class="clickable"
              (dblclick)="updateTemplate(template)"
              >{{ template.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.NAME' | translate }}</mat-label>
              <input matInput #searchNameInput [placeholder]="'TASK_TEMPLATE.NAME' | translate" />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                type="button"
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="categoryName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'TASK_TEMPLATE.TEAM_CATEGORY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">{{ template.category_name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCategory">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchCategoryAutocomplete
              [label]="'TASK_TEMPLATE.TEAM_CATEGORY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getCategoryAutocomplete"
              [optionFormatter]="formatCategoryOption"
              [valueFormatter]="formatCategoryOption"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isBackstage">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'TASK_TEMPLATE.BACKSTAGE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              *ngIf="template.is_backstage"
              class="label label-lg label-inline label-light-primary text-center"
            >
              {{ 'TASK_TEMPLATE.BACKSTAGE' | translate }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsBackstage">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.BACKSTAGE' | translate }}</mat-label>
              <mat-select #searchIsBackstageSelect>
                <mat-option value="">All</mat-option>
                <mat-option value="true">Backstage</mat-option>
                <mat-option value="false">Not Backstage</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isIntervention">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'TASK_TEMPLATE.INTERVENTION' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              *ngIf="template.default_view === 'INTERVENTION'"
              class="label label-lg label-inline label-light-info text-center"
            >
              {{ 'TASK_TEMPLATE.INTERVENTION' | translate }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsIntervention">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.INTERVENTION' | translate }}</mat-label>
              <mat-select #searchIsInterventionSelect>
                <mat-option value="">All</mat-option>
                <mat-option value="true">Intervention</mat-option>
                <mat-option value="false">Other</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="additionalOnly">
          <mat-header-cell *matHeaderCellDef>{{
            'TASK_TEMPLATE.ADDITIONAL_STEP' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              *ngIf="template.additional_only"
              class="label label-lg label-inline label-light-dark text-center"
            >
              {{ 'TASK_TEMPLATE.ADDITIONAL_STEP' | translate }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsAdditionalStep">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.ADDITIONAL_STEP' | translate }}</mat-label>
              <mat-select #searchIsAdditionalStepSelect>
                <mat-option value="">All</mat-option>
                <mat-option value="true">Additional Step</mat-option>
                <mat-option value="false">Not Additional Step</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="allRoles">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'TASK_TEMPLATE.ALL_USERS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <span
              *ngIf="template.all_roles"
              class="label label-lg label-inline label-light-warning text-center"
              >Allowed</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchAllRoles">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.ALL_USERS' | translate }}</mat-label>
              <mat-select #searchAllRolesSelect>
                <mat-option value="">All</mat-option>
                <mat-option value="true">Allowed</mat-option>
                <mat-option value="false">Not Allowed</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="resources">
          <mat-header-cell *matHeaderCellDef>{{
            'TASK_TEMPLATE.PROCESS_NAV' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let template" class="d-flex flex-center">
            <span
              *ngIf="!!template.resources?.length"
              inlineSVG="assets/media/svg/icons/General/process-nav.svg"
              class="svg-icon svg-icon-danger"
            ></span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchHasResources">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TASK_TEMPLATE.PROCESS_NAV' | translate }}</mat-label>
              <mat-select #searchHasResourcesSelect>
                <mat-option value="">All</mat-option>
                <mat-option value="true">Has Resources</mat-option>
                <mat-option value="false">No Resources</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let template">
            <button
              type="button"
              matTooltip="{{ 'TABLE.UPDATE' | translate }} Task Template"
              class="btn btn-sm btn-icon btn-light btn-hover-primary m-1"
              (click)="updateTemplate(template)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              *ngIf="userInfo?.userType === 'Admin'"
              type="button"
              matTooltip="{{ 'TABLE.DELETE' | translate }} Task Template"
              class="btn btn-sm btn-icon btn-light btn-hover-danger m-1"
              (click)="deleteTemplate(template)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
            <button
              type="button"
              matTooltip="{{ 'TABLE.DUPLICATE' | translate }} Task Template"
              class="btn btn-sm btn-icon btn-light btn-hover-warning m-1"
              (click)="duplicateTemplate(template)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/Duplicate.svg"
                class="svg-icon svg-icon-md svg-icon-warning"
              ></span>
            </button>
            <button
              type="button"
              matTooltip="Task Template Behavior"
              class="btn btn-sm btn-icon btn-light btn-hover-secondary m-1"
              (click)="setBehavior(template)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/Clipboard.svg"
                class="svg-icon svg-icon-md svg-icon-secondary"
              ></span>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              type="button"
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light w-50 m-1"
              (click)="resetSearchBar($event)"
            >
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
